<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div *ngIf="isPageReady" class="flex flex-col h-full">

    <div *ngIf="params.subtitle" class="px-3 pt-3 pb-2 text-sm" style="color: var(--p-text-muted-color)">
      {{ params.subtitle }}
    </div>

    <div class="flex-1 min-h-0 px-3 pb-3">
      <app-ag-grid [gridOptions]="gridOptions" class="h-full"></app-ag-grid>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised p-button-sm" icon="pi pi-download"
            (click)="onExport()">
      <span>Export to Excel</span>
    </button>
    <button pButton type="button" class="p-button-raised p-button-sm" (click)="onClose()">
      <span>Close</span>
    </button>
  </div>
</ng-template>
